import { FC } from "react";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { Auction } from "@/icons/outlined";

type EndAuctionButtonProps = {
  onClick?: (e: React.MouseEvent) => void;
  hideIcon?: boolean;
};

export const EndAuctionButton: FC<EndAuctionButtonProps> = ({ onClick, hideIcon = false }) => {
  const { t } = useTranslate();
  const { isPhoneScreen } = useMediaQuery();

  const showIcon = !hideIcon && !isPhoneScreen;

  return (
    <DashboardButton
      endIcon={showIcon ? <Auction /> : undefined}
      variant="outlined"
      vibe="neutral"
      size="medium"
      onClick={onClick}
      data-test="end-auction-button"
    >
      {t("campaignHub", "campaignCard.action.endAuction")}
    </DashboardButton>
  );
};
